import axiosInstance from '../utils/axios';
import API_CONFIG from '../config/api.config';

const gstReportService = {
  /**
   * Get GST report data
   * @param {string} startDate - Start date in YYYY-MM-DD format
   * @param {string} endDate - End date in YYYY-MM-DD format
   * @returns {Promise} GST report response
   */
  getGSTReport: async (startDate, endDate, nonGst = false) => {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (nonGst) params.append('nonGst', 'true');

      const response = await axiosInstance.get(
        `${API_CONFIG.ENDPOINTS.REPORTS}/gst?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching GST report:', error);
      throw error;
    }
  },

  /**
   * Get GSTR2 report data (Purchases)
   * @param {string} startDate - Start date in YYYY-MM-DD format
   * @param {string} endDate - End date in YYYY-MM-DD format
   * @returns {Promise} GSTR2 report response
   */
  getGSTR2Report: async (startDate, endDate) => {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await axiosInstance.get(
        `${API_CONFIG.ENDPOINTS.REPORTS}/gstr2?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching GSTR2 report:', error);
      throw error;
    }
  },

  /**
   * GSTR-3B summary + sales/purchase invoice rows for the period
   */
  getGSTR3BReport: async (startDate, endDate) => {
    try {
      const params = new URLSearchParams();
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const response = await axiosInstance.get(
        `${API_CONFIG.ENDPOINTS.REPORTS}/gstr3b?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching GSTR-3B report:', error);
      throw error;
    }
  }
};

export default gstReportService;

